/* eslint-disable @typescript-eslint/no-explicit-any */

import { PRINTER_ERRORS } from '../main/printer/types';
import { ExpectedError } from './errors';

export const isError = (arg: any): arg is Error => arg instanceof Error;

export const isPrinterError = (arg: any): arg is Error & { message: PRINTER_ERRORS } =>
  isError(arg) && Object.values<string>(PRINTER_ERRORS).includes(arg.message);

export const isErrorWithCode = (arg: any): arg is Error & { code: string } =>
  isError(arg) && 'code' in arg && typeof (arg as NodeJS.ErrnoException).code === 'string';
// ts-unused-exports:disable-next-line
export const isErrorWithErrno = (arg: any): arg is Error & { errno: number } =>
  isError(arg) && 'errno' in arg && typeof (arg as NodeJS.ErrnoException).errno === 'number';

export const isExpectedError = (arg: any): arg is ExpectedError =>
  isError(arg) && (arg as any).isExpected === true;

export const coerceError = (err: unknown): Error => {
  if (isError(err)) {
    return err;
  }
  if (typeof err === 'string') {
    return new Error(err);
  }
  try {
    return new Error(JSON.stringify(err));
  } catch (e) {
    return new Error('Error cannot be serialized');
  }
};
